import { ReactNode } from 'react';

import { isSSG } from 'modules/common/utils/isSSG';

import { ChainsListPageLayout } from '../ChainsListPageLayout';
import { ChainsListPageTitle } from '../ChainsListPageTitle';
import { ChainsSkeleton } from '../ChainsSkeleton';

interface BaseChainsProps {
  top?: ReactNode;
  loading: boolean;
  children: ReactNode;
}

export const BaseChains = ({ children, loading, top }: BaseChainsProps) => {
  return (
    <ChainsListPageLayout>
      {top}
      <ChainsListPageTitle />
      {loading && !isSSG() ? <ChainsSkeleton /> : <>{children}</>}
    </ChainsListPageLayout>
  );
};
